import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchOnlineFreeUsers } from '../redux/onlineLadies/operations';
import { servicesPost } from '../redux/services/operations';

import { selectUser } from '../redux/auth/selectors';
import { fetchFans } from '../redux/fans/operations';
import { fetchPresents } from '../redux/presents/operations';
import { getAllAnimation } from '../redux/animation/operations';
import { getPaidUser } from '../api/paidUsers';
import { updateUserBalance } from '../redux/auth/slice';
import { fetchAllAgencyUsers } from '../api/agencyUsers';
import { setAgencies } from '../redux/agencyUser/slice';
import { getNews } from '../redux/news/operations';

export const usePreLoadData = () => {
  const user = useSelector(selectUser);
  const dispatch = useDispatch();
  useEffect(() => {
    sessionStorage.removeItem(user?._id);
  }, [user?._id]);
  useEffect(() => {
    // dispatch(fetchVideoStories());
    dispatch(fetchOnlineFreeUsers());
    dispatch(servicesPost());
    dispatch(getNews());
    // dispatch(fetchTestimonials());
    dispatch(getAllAnimation());
  }, [dispatch]);

  useEffect(() => {
    if (user) {
      dispatch(fetchFans(user._id));
      fetchAllAgencyUsers().then(data => {
        dispatch(setAgencies(data));
      });
    }
  }, [user, dispatch]);

  useEffect(() => {
    if (user?.typeAccount === 'paidUser') {
      sessionStorage.removeItem(user?._id);
      getPaidUser(user._id).then(data => {
        dispatch(updateUserBalance(data.balance));
      });
      const filters = { senderId: user?._id };
      const pagination = { page: 1, perPage: 99999 };
      dispatch(fetchPresents({ filters, pagination }));
    }
  }, [user, dispatch]);
};
